import * as angular from "angular";
import {IController} from "angular";
import {LogisticsVehicle} from "../../models/logistics-vehicle.model";
import * as _ from "lodash";
import {LogisticsVehicleService} from "../../services/logistics-vehicle-service.service";
import {LogisticsVehiclesDialogsService} from "../../services/logistics-vehicles-dialogs-service.service";

export class LogisticsVehicleInfoCtrl implements IController {

  logisticsVehicle: LogisticsVehicle;

  public siteLabels: any;
  public labelsMap: any;
  public siteDistanceUnit: string;

  public vehicleType: any;

  constructor(private splitService, private $log, private logisticsVehiclesDialogsService: LogisticsVehiclesDialogsService, private $vehicles,
              private logisticsVehicleService: LogisticsVehicleService) {
    this.siteLabels = this.splitService.getSiteLabels();
    this.labelsMap = {};
    _.forEach(this.siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
    this.siteDistanceUnit = this.splitService.getSiteDistanceLargeUnit();
  }

  $onInit() {
    if (this.logisticsVehicle?.vehicleTypeId) {
      this._setVehicleType();
    }

  }

  openEditVehicleBasics(event) {
    this.logisticsVehiclesDialogsService.editVehicleBasics(event, this.logisticsVehicle)
      .then(({logisticsVehicle}) => {
        this.updateLogisticsVehicle(logisticsVehicle);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  openEditVehicleType(event) {
    this.logisticsVehiclesDialogsService.editVehicleType(event, this.logisticsVehicle, this.vehicleType)
      .then(({logisticsVehicle}) => {
        this.updateLogisticsVehicle(logisticsVehicle, true);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  openEditVehicleBackground(event) {
    this.logisticsVehiclesDialogsService.editVehicleBackground(event, this.logisticsVehicle)
      .then(({logisticsVehicle}) => {
        this.updateLogisticsVehicle(logisticsVehicle);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  openEditVehicleStatusAndInformation(event) {
    this.logisticsVehiclesDialogsService.editVehicleStatusAndInformation(event, this.logisticsVehicle)
      .then(({logisticsVehicle}) => {
        this.updateLogisticsVehicle(logisticsVehicle);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  openEditVehicleInsuranceInformation(event) {
    this.logisticsVehiclesDialogsService.editVehicleInsuranceInformation(event, this.logisticsVehicle)
      .then(({logisticsVehicle}) => {
        this.updateLogisticsVehicle(logisticsVehicle);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  updateLogisticsVehicle(logisticsVehicle, setType?: boolean) {
    this.logisticsVehicleService.updateLogisticsVehicle(logisticsVehicle)
      .then((updatedLogisticsVehicle) => {
        this.logisticsVehicle = updatedLogisticsVehicle;
        if (setType) {
          this._setVehicleType();
        }
      })
  }

  private _setVehicleType() {
    this.$vehicles(this.logisticsVehicle.vehicleTypeId).$asyncValue()
      .then((vehicleType) => {
        this.vehicleType = vehicleType;
      })

  }

}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleInfo', {
    bindings: {
      logisticsVehicle: '<'
    },
    template: require('./logistics-vehicle-info.html').default,
    controller: LogisticsVehicleInfoCtrl
  });

